import { environment } from './environments/environment';

declare global {
  interface Window {
    /** Declared by the end-to-end suite before the application's own scripts run. */
    __ninetyE2e?: boolean;
  }
}

/**
 * Whether the end-to-end suite is driving this page.
 *
 * `production` gates the global so a shipped build cannot be put into this mode by a page that sets
 * it: the production configuration replaces the environment file with one whose `production` is true,
 * and this then returns false whatever the page declares.
 *
 * Read where a run would otherwise be non-deterministic — Ionic's `animated` option and the
 * LaunchDarkly service.
 */
export function isDrivenByE2e(): boolean {
  return !environment.production && typeof window !== 'undefined' && window.__ninetyE2e === true;
}
